var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19912 22.6868C7.67842 23.2075 7.67842 24.0518 8.19912 24.5725C8.71982 25.0932 9.56404 25.0932 10.0847 24.5725L15.9991 18.6581L21.9134 24.5722C22.4341 25.0929 23.2783 25.0929 23.799 24.5722C24.3197 24.0515 24.3197 23.2072 23.799 22.6866L17.8848 16.7724L23.799 10.8582C24.3197 10.3375 24.3197 9.49325 23.799 8.97256C23.2783 8.45186 22.4341 8.45186 21.9134 8.97256L15.9991 14.8868L10.0847 8.9726C9.56402 8.45191 8.7198 8.45192 8.19911 8.97262C7.67841 9.49333 7.67842 10.3375 8.19913 10.8582L14.1135 16.7725L8.19912 22.6868Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ef69009966491e9adfbe3df656853b74.svg";
export { ForwardRef as ReactComponent };